import React, { useEffect } from 'react';
import styles from './NotFoundPage.module.scss';
import { translations } from './strings';
import { useNavigate, useLocation } from 'react-router-dom';

const language = navigator.language.includes('ro') ? 'ro' : 'en';
const { notFound } = translations[language];

const NotFoundPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/404') {
      navigate('/404', { replace: true });
    }
  }, [location, navigate]);

  return (
    <div className={styles.notFoundContainer}>
      <div className={styles.notFoundContent}>
        <h1 className={styles.errorCode}>{notFound.errorCode}</h1>
        <p className={styles.errorMessage}>{notFound.errorMessage}</p>
        <button
          className={styles.backButton}
          onClick={() => (window.location.href = '/')}
        >
          {notFound.backButton}
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
